// ensure code only executes when dom is fully loaded;
jQuery(document).ready(function($) {

(function( $ ){
  // var $module = $('#m-1678321330396').children('.module');
  // You can add custom Javascript code right here.
   
const intro = document.querySelector(".intro");
const text = intro.querySelector("#text1");
const text2 = intro.querySelector("#text2");
const text3 = intro.querySelector("#text3");

// Set initial opacity of text2 and text3 to 0
TweenMax.set(text2, { opacity: 0 });
TweenMax.set(text3, { opacity: 0 });


//SCROLLMAGIC
const controller = new ScrollMagic.Controller();

//Scenes
let scene = new ScrollMagic.Scene({
  duration: 4000,
  triggerElement: intro,
  triggerHook: 0,
})
  //.addIndicators()
  .setPin(intro)
  .addTo(controller);

//Text Animation

const textAnim = TweenMax.fromTo(text, 1, { opacity: 1 }, { opacity: 0 });

let scene2 = new ScrollMagic.Scene({
  duration: 1000,
  triggerElement: intro,
  triggerHook: 0
})
  //.addIndicators()
  .setTween(textAnim)
  .addTo(controller);

const textAnim2 = TweenMax.fromTo(
  text2,
  1,
  { opacity: 0, display: "none" },
  { opacity: 1, display: "block" }
);

let scene3 = new ScrollMagic.Scene({
  duration: 1000,
  triggerElement: intro,
  triggerHook: 0,
  offset: 1000
})
  .setTween(textAnim2)
  .addTo(controller);

const textAnim2Out = TweenMax.fromTo(text2, 1, { opacity: 1 }, { opacity: 0 });

let scene4 = new ScrollMagic.Scene({
  duration: 1000,
  triggerElement: intro,
  triggerHook: 0,
  offset: 2000
})
  //.addIndicators()
  .setTween(textAnim2Out)
  .addTo(controller);


const textAnim3 = TweenMax.fromTo(text3, 3, { opacity: 0 }, { opacity: 1 });

let scene5 = new ScrollMagic.Scene({
  duration: 1000,
  triggerElement: intro,
  triggerHook: 0,
  offset: 3000
})
  //.addIndicators()
  .setTween(textAnim3)
  .addTo(controller);


// Get the video element and its top position relative to the document
const video = document.querySelector('#scrollVideo');

//Video Animation
let accelamount = 0.1;
let scrollpos = 0;
let delay = 0;

scene.on("update", e => {
  scrollpos = e.scrollPos / 1000;
});

setInterval(() => {
  delay += (scrollpos - delay) * accelamount;
  //console.log(scrollpos, delay);

  video.currentTime = delay;
}, 33.3);

   video.loop = true;
   video.autoplay = false;
   video.muted = true;
   video.controls = false;
   video.play()

// use to avoid conflict with page container
// Get the element with class '.page-container'
// const pageContainer = document.querySelector('.page-container');

// Set the 'transform' property to 'none'
// pageContainer.style.transform = 'none';

})( jQuery );
});